module.exports = "<div id='error-dialog'>\r\n  <p class=\"dialog-message\">{{ data.message }}</p>\r\n  <mat-dialog-actions class=\"delete-buttons-div\">\r\n    <button mat-raised-button [mat-dialog-close]=\"true\" value=\"yes\" class=\"yes-btn\">Yes</button>\r\n    <button mat-raised-button [mat-dialog-close]=\"false\" value=\"yes\" class=\"no-btn\">No</button>\r\n  </mat-dialog-actions>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/confirm-pop-up/confirm-pop-up.component.html
// module id = ./src/app/common/confirm-pop-up/confirm-pop-up.component.html
// module chunks = main